(function () {
  if (window.jciWaggleFeaturedReviewLoaded) return;
  window.jciWaggleFeaturedReviewLoaded = true;

  function initializeReviewSection(section) {
    if (!section || section.dataset.reviewSectionReady === 'true') return;

    var slides = Array.from(section.querySelectorAll('[data-waggle-review-slide]'));
    var previous = section.querySelector('[data-waggle-review-previous]');
    var next = section.querySelector('[data-waggle-review-next]');
    var dots = Array.from(section.querySelectorAll('[data-waggle-review-dot]'));
    var reviewNotes = Array.from(section.querySelectorAll('[data-waggle-review-note]'));
    var photoGalleryElements = Array.from(section.querySelectorAll('[data-waggle-photo-gallery]'));
    var mobileMediaQuery = window.matchMedia('(max-width: 980px)');
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var photoGalleries = [];
    var photoGalleryCleanups = [];
    var resizeFrame = null;
    var resizeObserver = null;
    var isDisposed = false;

    if (!slides.length) return;

    section.dataset.reviewSectionReady = 'true';
    var hasCarouselControls = Boolean(slides.length > 1
      && previous
      && next
      && dots.length === slides.length);
    var activeIndex = Math.max(0, slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    }));

    function collapseReview(note) {
      var copy = note.querySelector('[data-waggle-review-copy]');
      var toggle = note.querySelector('[data-waggle-review-toggle]');

      note.classList.remove('is-expanded');
      if (copy) {
        copy.classList.remove('is-truncated');
        copy.style.removeProperty('--jci-wfr-review-lines');
      }
      if (!toggle) return;

      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Read More';
    }

    function measureReferenceCardHeight() {
      var referenceNote = reviewNotes[0];
      var visibleNote = reviewNotes.find(function (note) {
        return note.getClientRects().length > 0;
      });

      if (!referenceNote || !visibleNote) return 0;

      var cardWidth = visibleNote.getBoundingClientRect().width;
      if (!cardWidth) return 0;

      var clone = referenceNote.cloneNode(true);
      clone.classList.remove('is-expanded');
      clone.removeAttribute('data-waggle-review-note');
      clone.querySelectorAll('[id]').forEach(function (element) {
        element.removeAttribute('id');
      });

      var cloneToggle = clone.querySelector('[data-waggle-review-toggle]');
      if (cloneToggle) cloneToggle.hidden = true;

      // JCI: Measure natural review content so flex children cannot collapse the shared card height.
      var cloneBlockquote = clone.querySelector('blockquote');
      var cloneCopyRegion = clone.querySelector('.jci-waggle-featured-review__review-copy-region');
      var cloneCopy = clone.querySelector('[data-waggle-review-copy]');
      if (cloneBlockquote) cloneBlockquote.style.height = 'auto';
      if (cloneCopyRegion) cloneCopyRegion.style.flex = '0 0 auto';
      if (cloneCopy) {
        cloneCopy.classList.remove('is-truncated');
        cloneCopy.style.flex = '0 0 auto';
        cloneCopy.style.overflow = 'visible';
      }

      clone.style.position = 'absolute';
      clone.style.inset = '0 auto auto 0';
      clone.style.width = cardWidth + 'px';
      clone.style.height = 'fit-content';
      clone.style.minHeight = '0';
      clone.style.margin = '0';
      clone.style.visibility = 'hidden';
      clone.style.pointerEvents = 'none';

      section.appendChild(clone);
      var referenceHeight = Math.ceil(clone.getBoundingClientRect().height);
      clone.remove();

      return referenceHeight;
    }

    function updateReviewOverflow(note) {
      if (!note || note.getClientRects().length === 0) return;

      var copy = note.querySelector('[data-waggle-review-copy]');
      var toggle = note.querySelector('[data-waggle-review-toggle]');
      if (!copy || !toggle) return;

      copy.classList.remove('is-truncated');
      copy.style.removeProperty('--jci-wfr-review-lines');

      if (note.classList.contains('is-expanded')) {
        toggle.hidden = false;
        return;
      }

      toggle.hidden = true;
      if (copy.scrollHeight <= copy.clientHeight + 1) return;

      toggle.hidden = false;

      var lineHeight = parseFloat(window.getComputedStyle(copy).lineHeight);
      var availableHeight = copy.clientHeight;
      if (!lineHeight || !availableHeight) return;

      var visibleLines = Math.max(1, Math.floor((availableHeight - 1) / lineHeight));
      copy.style.setProperty('--jci-wfr-review-lines', visibleLines);
      copy.classList.add('is-truncated');
    }

    function applyReviewCardCap() {
      if (!reviewNotes.length) return;

      section.style.removeProperty('--jci-wfr-review-card-height');
      reviewNotes.forEach(function (note) {
        var toggle = note.querySelector('[data-waggle-review-toggle]');
        collapseReview(note);
        if (toggle) toggle.hidden = true;
      });

      var referenceHeight = measureReferenceCardHeight();
      if (!referenceHeight) return;

      section.style.setProperty('--jci-wfr-review-card-height', referenceHeight + 'px');

      reviewNotes.forEach(function (note) {
        updateReviewOverflow(note);
      });
    }

    function scheduleReviewCardCap() {
      if (isDisposed) return;
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () {
        resizeFrame = null;
        applyReviewCardCap();
      });
    }

    function addPhotoGalleryListener(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options);
      photoGalleryCleanups.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function initializePhotoGallery(gallery) {
      var track = gallery.querySelector('[data-waggle-photo-track]');
      var photoSlides = track
        ? Array.from(track.querySelectorAll('[data-waggle-photo-slide]'))
        : [];
      var photoDots = Array.from(gallery.querySelectorAll('[data-waggle-photo-dot]'));
      var scrollFrame = null;

      if (!track || !photoSlides.length) return null;

      photoSlides.forEach(function (photoSlide, photoIndex) {
        var mediaType = photoSlide.querySelector('video') ? 'Video' : 'Photo';
        photoSlide.setAttribute('aria-label', mediaType + ' ' + (photoIndex + 1) + ' of ' + photoSlides.length);
      });

      function photoOffset(photoIndex) {
        var firstOffset = photoSlides[0].offsetLeft;
        return photoSlides[photoIndex].offsetLeft - firstOffset;
      }

      function closestPhotoIndex() {
        var scrollPosition = track.scrollLeft;
        var closestIndex = 0;
        var closestDistance = Infinity;

        photoSlides.forEach(function (photoSlide, photoIndex) {
          var distance = Math.abs(scrollPosition - photoOffset(photoIndex));
          if (distance >= closestDistance) return;
          closestDistance = distance;
          closestIndex = photoIndex;
        });

        return closestIndex;
      }

      function updatePhotoState(photoIndex) {
        var activePhotoIndex = Math.max(0, Math.min(photoIndex, photoSlides.length - 1));

        photoDots.forEach(function (photoDot, dotIndex) {
          var isActive = dotIndex === activePhotoIndex;
          photoDot.classList.toggle('is-active', isActive);
          photoDot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      function showPhoto(photoIndex, shouldAnimate) {
        var nextPhotoIndex = Math.max(0, Math.min(photoIndex, photoSlides.length - 1));
        var nextScrollPosition = photoOffset(nextPhotoIndex);
        updatePhotoState(nextPhotoIndex);

        if (!mobileMediaQuery.matches) return;

        if (typeof track.scrollTo === 'function') {
          track.scrollTo({
            left: nextScrollPosition,
            behavior: shouldAnimate && !reducedMotionQuery.matches ? 'smooth' : 'auto'
          });
        } else {
          track.scrollLeft = nextScrollPosition;
        }
      }

      function updateGalleryMode() {
        if (mobileMediaQuery.matches) {
          gallery.setAttribute('role', 'region');
          gallery.setAttribute('aria-roledescription', 'carousel');
        } else {
          gallery.setAttribute('role', 'group');
          gallery.removeAttribute('aria-roledescription');
        }
      }

      function handlePhotoScroll() {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(function () {
          scrollFrame = null;
          updatePhotoState(closestPhotoIndex());
        });
      }

      if (photoSlides.length > 1) {
        addPhotoGalleryListener(track, 'scroll', handlePhotoScroll, { passive: true });
        /* JCI: Inner media swipes never advance reviews; outer reviews remain arrow-controlled only. */

        photoDots.forEach(function (photoDot) {
          function handlePhotoDotClick() {
            showPhoto(Number(photoDot.dataset.wagglePhotoDot), true);
          }
          addPhotoGalleryListener(photoDot, 'click', handlePhotoDotClick);
        });
      }

      updatePhotoState(0);
      updateGalleryMode();

      return {
        slide: gallery.closest('[data-waggle-review-slide]'),
        reset: function () {
          showPhoto(0, false);
        },
        updateMode: updateGalleryMode,
        cleanup: function () {
          if (scrollFrame) cancelAnimationFrame(scrollFrame);
        }
      };
    }

    function resetPhotoGalleryForSlide(slide) {
      if (!mobileMediaQuery.matches) return;

      photoGalleries.forEach(function (photoGallery) {
        if (photoGallery.slide === slide) photoGallery.reset();
      });
    }

    function showSlide(index) {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      requestAnimationFrame(function () {
        resetPhotoGalleryForSlide(slides[activeIndex]);
        updateReviewOverflow(slides[activeIndex].querySelector('[data-waggle-review-note]'));
      });
    }

    photoGalleries = photoGalleryElements
      .map(initializePhotoGallery)
      .filter(Boolean);

    function handleMobileGalleryBreakpoint() {
      photoGalleries.forEach(function (photoGallery) {
        photoGallery.updateMode();
      });
      if (!mobileMediaQuery.matches) return;
      requestAnimationFrame(function () {
        resetPhotoGalleryForSlide(slides[activeIndex]);
      });
    }

    if (mobileMediaQuery.addEventListener) {
      addPhotoGalleryListener(mobileMediaQuery, 'change', handleMobileGalleryBreakpoint);
    } else if (mobileMediaQuery.addListener) {
      mobileMediaQuery.addListener(handleMobileGalleryBreakpoint);
      photoGalleryCleanups.push(function () {
        mobileMediaQuery.removeListener(handleMobileGalleryBreakpoint);
      });
    }

    if (hasCarouselControls) {
      previous.addEventListener('click', function () {
        showSlide(activeIndex - 1);
      });

      next.addEventListener('click', function () {
        showSlide(activeIndex + 1);
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          showSlide(Number(dot.dataset.waggleReviewDot));
        });
      });
    }

    reviewNotes.forEach(function (note) {
      var toggle = note.querySelector('[data-waggle-review-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var willExpand = !note.classList.contains('is-expanded');
        var copy = note.querySelector('[data-waggle-review-copy]');

        note.classList.toggle('is-expanded', willExpand);
        toggle.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
        toggle.textContent = willExpand ? 'Read Less' : 'Read More';

        if (willExpand && copy) {
          copy.classList.remove('is-truncated');
          copy.style.removeProperty('--jci-wfr-review-lines');
        } else {
          requestAnimationFrame(function () {
            updateReviewOverflow(note);
          });
        }
      });
    });

    section.addEventListener('keydown', function (event) {
      if (!hasCarouselControls || !event.target.closest('.jci-waggle-featured-review__controls')) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(activeIndex + 1);
      }
    });

    section.addEventListener('shopify:block:select', function (event) {
      var selectedSlide = event.target.closest('[data-waggle-review-slide]');
      if (!selectedSlide) return;
      showSlide(Number(selectedSlide.dataset.slideIndex));
    });

    showSlide(activeIndex);
    scheduleReviewCardCap();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleReviewCardCap);
    }

    if ('ResizeObserver' in window) {
      var observedWidth = section.getBoundingClientRect().width;
      resizeObserver = new ResizeObserver(function () {
        var nextWidth = section.getBoundingClientRect().width;
        if (Math.abs(nextWidth - observedWidth) < 1) return;
        observedWidth = nextWidth;
        scheduleReviewCardCap();
      });
      resizeObserver.observe(section);
    } else {
      window.addEventListener('resize', scheduleReviewCardCap);
    }

    section.addEventListener('shopify:section:unload', function () {
      isDisposed = true;
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      if (resizeObserver) resizeObserver.disconnect();
      photoGalleries.forEach(function (photoGallery) {
        photoGallery.cleanup();
      });
      photoGalleryCleanups.forEach(function (cleanup) {
        cleanup();
      });
      photoGalleryCleanups = [];
      window.removeEventListener('resize', scheduleReviewCardCap);
      delete section.dataset.reviewSectionReady;
    }, { once: true });
  }

  function initializeAllReviewSections(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-waggle-review-section]')) {
      initializeReviewSection(scope);
    }

    scope.querySelectorAll('[data-waggle-review-section]').forEach(initializeReviewSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAllReviewSections(document);
    });
  } else {
    initializeAllReviewSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllReviewSections(event.target);
  });
})();
